/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInterestSettingsAppAction} from '../api'

 export const useQueryGetInterestSettingsAppAction = createReactQueryHook('getInterestSettingsAppAction', getInterestSettingsAppAction)
